var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0853 4.78564H1.22815L15.1567 16.2585L29.2428 4.81779C29.1912 4.80272 29.1386 4.79199 29.0853 4.78564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8328 18.4742C15.438 18.7974 14.8701 18.7974 14.4753 18.4742L0.156738 6.67773V25.1427C0.156738 25.7345 0.636432 26.2142 1.22819 26.2142H29.0853C29.677 26.2142 30.1567 25.7345 30.1567 25.1427V6.83631L15.8328 18.4742Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.156738 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail21);
export default __webpack_public_path__ + "static/media/email21.f9eb1a07e76e4fef75ba07d7d41af3d4.svg";
export { ForwardRef as ReactComponent };